import { MonthlyFee } from '@/store/Billing/types';

/**
 * If the option WITHOUT_MINIMUM is selected, the minimum value will be set to 0.00 and disabled field
 */
export const BILLING_TYPE = [
    { label: 'Percentual (com piso mínimo) ', value: MonthlyFee.MINIMUM },
    { label: 'Percentual (sem piso)', value: MonthlyFee.PERCENTAGE_NO_MINIMUM },
    { label: 'Fixa', value: MonthlyFee.FIXED },
];

export const BillingLabel: Record<MonthlyFee, string> = {
    [MonthlyFee.MINIMUM]: 'Percentual (com piso mínimo)',
    [MonthlyFee.PERCENTAGE_NO_MINIMUM]: 'Percentual (sem piso)',
    [MonthlyFee.FIXED]: 'Fixa',
};

export const DEFAULT_SPLIT_VALUE = 6.0;
export const DEFAULT_MONTHLY_PAYMENT = 30000;
